import React, { FormEvent, useEffect, useRef, useState, CSSProperties } from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import { CommunityHero } from "../../components/CommunityHero/CommunityHero";
import APIService from '../../lib/api.service';

/* import videoPoster from "../../images/FPO-video-poster.jpg"; */
/* import { Video } from "../../components/Video/Video"; */

import superFooterSemicircle from "../../images/community-footer-semicircle-blue.svg";
import { Button } from "../../components/Button/Button";
import { Banner } from "../../components/Banner/Banner";
import { IconsBlocks } from "../../components/IconBlocks/IconBlocks";
import { PulseLoader } from 'react-spinners';

import imageTextImage from "../../images/apartment-projects-image.jpg";
import formImage from "../../images/Apartment project form image@2x.jpg";

export const ApartmentProjects = (): React.JSX.Element => {
  const formRef = useRef<HTMLFormElement | null>(null);

  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    street: '',
    state: 'CA',
    city: '',
    businessname: '',
    ucount: '',
    website: '',
  });

  const [showForm, setShowForm] = useState(true);
  const [showSuccessPrompt, setShowSuccessPrompt] = useState(false);
  const [showFailedPrompt, setShowFailedPrompt] = useState(false);

  // Loading spinner
  const [showLoader, setShowLoader] = useState(false);
  const [color, setColor] = useState("#FFA500");
  const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "orange",
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    setShowLoader(true); // Set spinner
    setShowForm(false);
    setShowSuccessPrompt(false);
    setShowFailedPrompt(false);

    if (formData.website) {
      setShowSuccessPrompt(true);
      setShowLoader(false);
      return;
    }

    const payload = { ...formData };
    delete payload.website;

    payload["datestamp"] = new Date().toJSON().slice(0, 10); // "YYYY-MM-DD"
    payload["address"] = `${payload["street"]}, ${payload["city"]}, ${payload["state"]}`;
    payload["UTYPE"] = "M";
    payload["phone"] = payload["phone"].replaceAll("-", "").trim() // Sanitize to "XXXXXXXXXX"

    payload["vserviceloc"] = null; // Pulled from previous form
    payload["caccount"] = null;
    payload["campaign"] = null;
    payload["servicelevel"] = null;
    payload["serviceable"] = "No";

    try {
      const submit = await APIService.postContactInfo(JSON.stringify(payload));

      setShowLoader(false);
      if (submit.status === 201) {
        setShowSuccessPrompt(true);
      } else if (submit.status === 500) {
        setShowFailedPrompt(true);
        setShowForm(true);
      }

    } catch (error) {
      setShowLoader(false);
      setShowFailedPrompt(true);
      setShowForm(true);
    }
  };

  return (
    <>
      <Helmet>
        <title>{ROUTES.apartmentProjects.title}</title>
        <meta
          name="description"
          content="Cityside Fiber is the premier choice for high-speed internet and WiFi connectivity for owners and residents of apartment complexes."
        />

        <meta property="og:title" content={`${ROUTES.apartmentProjects.title}`} />
        <meta property="og:description" content="Cityside Fiber is the premier choice for high-speed internet and WiFi connectivity for owners and residents of apartment complexes." />
        <meta property="og:url" content="https://www.citysidefiber.com/apartment-projects" />
      </Helmet>

      <CommunityHero type="Apartment" />

      <section className="grid-12 community-page community-page--apartment">
        <div className="image-text">
          <div className="image-text__image">
            <img src={imageTextImage} alt="" />
          </div>
          <div className="image-text__text">
            <h2>Do you own or manage an Apartment Building or Complex?</h2>
            <p>
              Contact us today to get your property connected. Cityside Fiber
              can also develop a seamless private network for resident access
              that covers your common areas, pool areas, parking areas, and
              security systems with a secure WiFi signal.
            </p>

            <p>
              Our team looks forward to meeting with the Property Manager to
              discuss your options.
            </p>
          </div>
        </div>

        <div className="wifi-solutions">
          <div className="wifi-solutions__text">
            <div>
              <h2>
                Managed WiFi and whole complex solutions for multifamily owners
              </h2>
              <p>1 Gig+ fiber internet to every resident means...</p>
            </div>
            <Button
              href="#form-section"
              target="_self"
              size="lg"
              gradient="blue"
            >
              Submit my building info
            </Button>
          </div>
          <div className="wifi-solutions__icon-cards">
            <IconsBlocks
              data={[
                {
                  icon: "clock",
                  iconColor: "ocean-blue",
                  borderColor: "ocean-blue",
                  text: "Future proof infrastructure",
                },
                {
                  icon: "piggy-bank",
                  iconColor: "citron-yellow",
                  borderColor: "citron-yellow",
                  text: "Increased property value",
                },
                {
                  icon: "wrench",
                  iconColor: "tangerine-orange",
                  borderColor: "tangerine-orange",
                  text: "Less maintenance",
                },
                {
                  icon: "building",
                  iconColor: "marina-blue",
                  borderColor: "marina-blue",
                  text: "Easy, less intrusive install",
                },
                {
                  icon: "chart-line",
                  iconColor: "daylight-blue",
                  borderColor: "daylight-blue",
                  text: "Less turnover, happier tenants",
                },
              ]}
            />
          </div>
          {/* <div className="video-section">
            <Video
              src="https://www.youtube.com/embed/4d6Wc1ys5SU?si=yaskOAHmTW5SY09M"
              poster={videoPoster}
              iconColor="white"
            />
          </div> */}
        </div>
      </section>
      <section className="community-page__form-section ">
        <div id="form-section" className="form-section-scrollto"></div>

        <div className="inner">
          <div className="image-side">
            <img src={formImage} alt="" />
            <div className="overlay"></div>
            <div className="text">
              <h2 className="headline__h2">Managed WiFi</h2>
              <Button
                className="bg-color--daylight-blue color--marina-blue form-pic-button"
                path="mailto:hello@citysidefiber.com"
                size="sm"
              >
                hello@citysidefiber.com
              </Button>
              <div className="headline__h3">
                Bulk agreements for simplified service
              </div>
            </div>
          </div>
          <div className="form-side">
            {showLoader &&
              <div className="loader-container">
                <PulseLoader
                  color={color}
                  loading={showLoader}
                  cssOverride={override}
                  size={50}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            }

            {showSuccessPrompt &&
              <div className="loader-container">
              <h3 className="headline__h3 color--marina-blue">
                Your community interested has been submitted! If you have any questions, please contact us at <a href="mailto:concierge@citysidefiber.com"> concierge@citysidefiber.com.</a>
              </h3>
              </div>
            }

            {showForm &&
            <div>
            <form id="form" ref={formRef} onSubmit={onSubmit}>
              <h3 className="headline__h3 color--marina-blue">
                Submit your community interest
              </h3>

              <div className="honeypot" aria-hidden="true">
                <label htmlFor="website">Website</label>
                <input
                  id="website"
                  name="website"
                  type="text"
                  autoComplete="off"
                  tabIndex={-1}
                  value={formData.website}
                  onChange={handleChange}
                />
              </div>

              {showFailedPrompt &&
              <div>
              <p>
                Hmm... it looks like we're having trouble submitting your interest. Try again in a couple minutes, and if that doesn't work, please contact us at <a href="mailto:concierge@citysidefiber.com"> concierge@citysidefiber.com.</a>
              </p>
              </div>
              }

              <div className="multi-column-container">
                <div className="input-container">
                  <label htmlFor="firstname">First Name</label>
                  <input
                    name="firstname"
                    type="text"
                    value={formData.firstname}
                    onChange={handleChange}
                  />
                </div>

                <div className="input-container">
                  <label htmlFor="lastname">Last Name</label>
                  <input
                    name="lastname"
                    type="text"
                    value={formData.lastname}
                    onChange={handleChange}
                  />
                </div>

                <div className="input-container">
                  <label htmlFor="email">Email</label>
                  <input
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="input-container">
                <label htmlFor="street">Street Address</label>
                <input
                  name="street"
                  type="text"
                  autoComplete="off"
                  placeholder="Steet Address"
                  value={formData.street}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="multi-column-container">
                <div className="input-container">
                  <label htmlFor="city">City</label>
                  <input
                    name="city"
                    type="text"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>

                <div className="select-container">
                  <label htmlFor="state">State</label>
                  <select id="state" name="state" defaultValue="CA" required>
                    <option value="CA">California</option>
                  </select>
                </div>
              </div>

              <div className="multi-column-container">
                <div className="input-container">
                  <label htmlFor="businessname">Apartment Name</label>
                  <input
                    name="businessname"
                    type="text"
                    placeholder="Building / Complex Name"
                    value={formData.businessname}
                    onChange={handleChange}
                  />
                </div>

                <div className="input-container">
                  <label htmlFor="ucount">Unit Count</label>
                  <input
                    name="ucount"
                    type="text"
                    placeholder="Number of Units in Complex"
                    value={formData.ucount}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="input-container">
                <label htmlFor="phone">Phone</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  pattern='[0-9]{3}-?[0-9]{3}-?[0-9]{4}'
                  placeholder='XXX-XXX-XXXX'
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <Button
                type="submit"
                className="btn--lg-extra-padding"
                size="md-to-lg"
                fullWidth={true}
              >
                Submit
              </Button>
            </form>
            </div>
            }
          </div>

        </div>
      </section>
      <section className="community-page__super-footer">
        <div className="inner">
          <h2>
            Fiber broadband increases rental and property values in MDUs by 8%
            and 2.8%, respectively, adding 11% to NOI per unit on average*
          </h2>
          <div className="citation">*survey by RVA, LLC (2016)</div>
        </div>
        <img className="semicircle" src={superFooterSemicircle} alt="" />
      </section>
      <Banner
        headline="Community-wide Managed WiFi"
        text="Bulk agreements for simplified service"
        btnText="hello@citysidefiber.com"
        btnLink={"mailto:hello@citysidefiber.com"}
      />
    </>
  );
};
